import { z } from 'zod';

export const StatusSchema = z.enum([
  'Member',
  'Amethyst',
  'Topaz',
  'Aquamarine',
  'Opal',
  'Emerald',
  'Ruby',
  'Sapphire',
  'Diamond',
  'Vip',
]);

export const PlayerStatusStateSchema = z.enum([
  'ToBePromoted',
  'ToBeDemoted',
  'ToBeKept',
  'Expired',
  'Active',
  'Completed',
]);

export const EventTypeSchema = z
  .enum(['Onboarding', 'StatusChange'])
  .or(z.string());

export const EventDetailsSchema = z.object({
  loyaltyStatus: StatusSchema,
  statusState: PlayerStatusStateSchema,
});

export const EventSchema = z.object({
  id: z.number(),
  type: EventTypeSchema,
  details: EventDetailsSchema.optional(),
});

export const EventsSchema = z.array(EventSchema);

export const EventsResponseSchema = z.object({
  events: EventsSchema,
});
